export enum DatasetId {
  MODIS = 'MODIS',
  DEM = 'DEM',
  L8L1C = 'L8L1C',
  LOTL1 = 'LOTL1',
  LOTL2 = 'LOTL2',
  LTML1 = 'LTML1',
  LTML2 = 'LTML2',
  LETML1 = 'LETML1',
  LETML2 = 'LETML2',
  LMSSL1 = 'LMSSL1',
  S2L1C = 'S2L1C',
  S1GRD = 'S1GRD',
  S3OLCI = 'S3OLCI',
  S3SLSTR = 'S3SLSTR',
  S5PL2 = 'S5PL2',
  S2L2A = 'S2L2A',
  HLS = 'HLS',
  BYOC = 'CUSTOM',
}
